import React, { useState } from "react";
import DemoModal from "./DemoModal";
import { siteConfig } from "../../config/siteConfig";

const REASSURANCE_ITEMS = [
  "Acceso inmediato",
  "Cancela cuando quieras",
  "Pago seguro con Stripe",
];

const Hero = ({ onCtaClick }) => {
  const [isDemoOpen, setIsDemoOpen] = useState(false);
  const { hero, stats } = siteConfig;

  return (
    <>
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 via-teal-50/50 to-white" />
        <div className="absolute top-20 left-10 w-72 h-72 bg-emerald-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob" />
        <div className="absolute top-40 right-10 w-72 h-72 bg-teal-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000" />
        <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-green-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-100 rounded-full border border-emerald-200 mb-8">
              <span className="w-2 h-2 bg-emerald-600 rounded-full animate-pulse" />
              <span className="text-xs font-bold text-emerald-700 uppercase tracking-wider">
                {hero.badge}
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-6">
              <span className="bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
                {hero.titleLine1}
              </span>
              <br />
              <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                {hero.titleLine2}
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-slate-600 max-w-3xl mx-auto mb-10">
              {hero.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                onClick={onCtaClick}
                className="group px-8 py-4 bg-gradient-to-r from-emerald-600 to-teal-600 text-white text-lg font-bold rounded-2xl shadow-xl shadow-emerald-200 hover:shadow-2xl hover:scale-105 transition-all duration-300 flex items-center gap-2"
              >
                <span>{hero.primaryCta}</span>
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
              <button
                onClick={() => setIsDemoOpen(true)}
                className="group relative px-8 py-4 bg-white text-slate-900 text-lg font-black rounded-2xl transition-all duration-300 hover:scale-105 active:scale-95 shadow-[0_0_20px_rgba(5,150,105,0.15)] hover:shadow-[0_0_30px_rgba(5,150,105,0.3)] flex items-center gap-3 border-2 border-transparent"
                style={{
                  background:
                    "linear-gradient(white, white) padding-box, linear-gradient(to right, #059669, #0d9488) border-box",
                }}
              >
                <div className="absolute inset-0 bg-emerald-50 opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl -z-10" />
                <div className="relative flex items-center gap-3">
                  <div className="bg-emerald-600 text-white p-1 rounded-full group-hover:rotate-12 transition-transform shadow-lg shadow-emerald-200">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                    </svg>
                  </div>
                  <span className="bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent group-hover:from-emerald-700 group-hover:to-teal-600 transition-all">
                    {hero.secondaryCta}
                  </span>
                </div>
                <span className="absolute -top-3 -right-3 px-2 py-1 bg-emerald-500 text-white text-[10px] font-black uppercase tracking-tighter rounded-lg shadow-lg rotate-12 group-hover:rotate-0 transition-transform">
                  {hero.secondaryCtaBadge}
                </span>
              </button>
            </div>

            <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 mt-6">
              {REASSURANCE_ITEMS.map((item, idx) => (
                <span key={idx} className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500">
                  <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                  </svg>
                  {item}
                </span>
              ))}
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto mt-20">
              {stats.map((stat, idx) => (
                <div className="text-center" key={idx}>
                  <div className="text-3xl md:text-4xl font-black text-emerald-600">
                    {stat.value}
                  </div>
                  <div className="text-sm text-slate-600 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <DemoModal isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} onRegister={onCtaClick} />
    </>
  );
};

export default Hero;
